export default __webpack_public_path__ + "static/board-template4-dba582f95124675556e791a19fd0fc6d.png";